function addToCart(productId) {
    const selectedInput = document.querySelector(`input[name="size-${productId}"]:checked`);
    const errorMessage = document.getElementById(`error-message-${productId}`);

    if (!selectedInput) {
        errorMessage.style.display = 'block';
        return;
    }

    errorMessage.style.display = 'none';
    const variantId = selectedInput.value;
    const quantity = 1;

    VueMinicart.addItem({
        id: variantId,
        quantity: quantity
    });


    const upsellElement = document.querySelector(`[data-product-id="${productId}"]`);

    if (upsellElement) {
        upsellElement.style.transition = 'opacity 0.3s ease';
        upsellElement.style.opacity = '0';

        setTimeout(() => {
            upsellElement.style.display = 'none';
        }, 300);
    }

    setTimeout(() => {
        selectedInput.checked = false;
    }, 300);
}

function slideRecommendations(direction) {
    const carousel = document.getElementById('recommendationsCarousel');
    const scrollAmount = 200;

    carousel.scrollBy({
        left: direction * scrollAmount,
        behavior: 'smooth'
    });
}

document.addEventListener('DOMContentLoaded', () => {
    fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
            const cartProductIds = cart.items.map(item => item.product_id);
            const upsellItems = document.querySelectorAll('.recommendation-item');

            let visibleCount = 0;
            upsellItems.forEach(item => {
                const productId = parseInt(item.dataset.productId, 10);
                if (cartProductIds.includes(productId) || visibleCount >= 15) {
                    item.style.display = 'none';
                } else {
                    item.style.display = 'block';
                    visibleCount++;
                }
            });
        });

});

document.querySelectorAll('.size-option input').forEach(input => {
    input.addEventListener('click', (event) => {
        const sizeOptions = event.target.closest('.size-options').querySelectorAll('input');
        sizeOptions.forEach(el => el.checked = false);

        event.target.checked = true;
    });
});
 